import React, { useEffect, Suspense, lazy } from 'react';
import ReactGA from "react-ga4";
import CookieBanner, { hasAnalyticsConsent } from "./components/CookieBanner/CookieBanner";
import { isAppLocation, isAppPath, isFramedLocation, isFramedPath } from "./lib/embedRoute";
import WebAssistantHomeOnly from "./components/WebAssistantHomeOnly";  
import BrandCursor from "./components/BrandCursor";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
// import TagManager from 'react-gtm-module';



import ScrollTop from "./components/ScrollTop";
import AppErrorBoundary from "./components/AppErrorBoundary";
import WebinarTopBar from "./components/WebinarBanner/WebinarTopBar";
import RequireSession from "./components/RequireSession";
import Home from './pages/Home/Home';
import Error404 from './pages/error404';
const About = lazy(() => import("./pages/About/About"));
// BlogDetails ya no se enruta: el detalle de artículo lo sirve Next.js en /blog/:slug.
// import Resources from "./pages/Resources/Resources";
const Contact = lazy(() => import("./pages/Contact/Contact"));
// import HeaderStyleFive from "./pages/HeaderStyleFive/HeaderStyleFive";
// import HeaderStyleFour from "./pages/HeaderStyleFour/HeaderStyleFour";
// import HeaderStyleSeven from "./pages/HeaderStyleSeven/HeaderStyleSeven";
// import HeaderStyleSix from "./pages/HeaderStyleSix/HeaderStyleSix";
// import HomeThree from "./pages/HomeThree/HomeThree";
// import HomeTwo from "./pages/HomeTwo/HomeTwo";
const Portfolio = lazy(() => import("./pages/Portfolio/Portfolio"));
const SCActivation = lazy(() => import("./pages/SCActivation/SCActivation"));




// import PortfolioDetails from "./pages/PortfolioDetails/PortfolioDetails";
const ServiceDetail = lazy(() => import("./pages/ServiceDetail/ServiceDetail"));
const Services = lazy(() => import("./pages/Services/Services"));
// import ServicesDetails from "./pages/ServicesDetails/ServicesDetails";
// OCULTA 2026-10-28 (pedido del owner): /team no se borra, solo se oculta. Para volver a publicarla, deshacer los cambios marcados «OCULTA 2026-10-28».
// const Team = lazy(() => import("./pages/Team/Team"));
// import TeamDetails from "./pages/TeamDetails/TeamDetails";

const CorePrelaunch = lazy(() => import("./pages/CorePrelaunch/CorePrelaunch"));
const Pricing = lazy(() => import('./pages/Pricing/Pricing'));
const Documentation = lazy(() => import('./pages/Documentation/Documentation'));
const Partnerships = lazy(() => import('./pages/Partnerships/Partnerships'));
const Playbooks = lazy(() => import('./pages/Features/Features'));
// Demo de un Playbook con la marca del cliente. Prototipo: la version definitiva
// ira en /d/<token>. Ver ANALISIS-DEMOS-PLAYBOOK-MARCA-BLANCA.md.
const PlaybookDemo = lazy(() => import('./pages/PlaybookDemo/PlaybookDemo'));
// Próximo lanzamiento (no enlazado en el sitio; se llega desde el Customer Portal).
const AssistantsPreview = lazy(() => import('./pages/PlaybookDemo/AssistantsPreview'));
// UN componente suelto, sin clave, para el <iframe> de CORE-Front. Igual que
// /embed: sin cromo del sitio, sin widgets flotantes y sin Analytics.
const ComponentPreview = lazy(() => import('./pages/PlaybookDemo/ComponentPreview'));
// Componentes de demo que la agencia embebe con un <iframe> en SU web (el
// snippet lo da el Customer Portal). Sin cromo del sitio ni Analytics.
const PlaybookEmbed = lazy(() => import('./pages/Embed/PlaybookEmbed'));
const Demo = lazy(() => import('./pages/Demo/Demo'));
// Demo VERTICAL del seguimiento comercial (de momento solo interfaz, sin WhatsApp real).
const DemoAgentCommercial = lazy(() => import('./pages/DemoAgentCommercial/DemoAgentCommercial'));
const BlogHandoff = lazy(() => import('./pages/BlogHandoff'));
const Resources = lazy(() => import('./pages/Resources/Resources'));
const Jobs = lazy(() => import('./pages/Jobs/Jobs'));
const Press = lazy(() => import('./pages/Press/Press'));
const Operators = lazy(() => import('./pages/Operators/Operators'));
const Reviews = lazy(() => import('./pages/Reviews/Reviews'));
const Platform = lazy(() => import('./pages/Platform/Platform'));
const Changelog = lazy(() => import('./pages/Changelog/Changelog'));
const Guidelines = lazy(() => import('./pages/Guidelines/Guidelines'));
const Faq = lazy(() => import('./pages/Faq/Faq'));
const FeatureVote = lazy(() => import('./pages/FeatureVote/FeatureVote'));
const HowItWorks = lazy(() => import('./pages/HowItWorks/HowItWorks'));
const ProductTour = lazy(() => import('./pages/ProductTour/ProductTour'));
const CustomerPortal = lazy(() => import('./pages/CustomerPortal/CustomerPortal'));
const CustomerPortalDashboard = lazy(() => import('./pages/CustomerPortal/Dashboard/CustomerPortalDashboard'));
const GetStarted = lazy(() => import('./pages/GetStarted/GetStarted'));
const AiKitLanding = lazy(() => import('./pages/AiKit/AiKitLanding'));
const AiCommercialLanding = lazy(() => import('./pages/AiCommercial/AiCommercialLanding'));
// Embudo en inglés del vertical «seguimiento comercial» (2026-10-26): destino de anuncios y orgánico.
const SalesFollowUpLanding = lazy(() => import('./pages/SalesFollowUp/SalesFollowUpLanding'));
// Landing de la parte consultiva (consultoría y procesos a medida), 2026-10-28.
const ConsultingLanding = lazy(() => import('./pages/Consulting/ConsultingLanding'));
// Landing de InvokeApp Connect (piloto, sin indexar). Desde el 2026-11-03 es la variante «la frase es
// la maqueta» (antes /connect3); las anteriores (ConnectPage y ConnectLanding) quedan sin ruta.
const ConnectPage = lazy(() => import('./pages/Connect/variants/Connect3Page'));
// Variantes de diseño de Connect que no se eligieron (2026-11-03): sin indexar y sin enlaces.
const Connect2Page = lazy(() => import('./pages/Connect/variants/Connect2Page'));
const Connect4Page = lazy(() => import('./pages/Connect/variants/Connect4Page'));
// Segunda tanda (2026-11-03), distintas en sustancia: producto en oscuro, reportaje con fotos y conversación.
const Connect5Page = lazy(() => import('./pages/Connect/variants/Connect5Page'));
const Connect6Page = lazy(() => import('./pages/Connect/variants/Connect6Page'));
const Connect7Page = lazy(() => import('./pages/Connect/variants/Connect7Page'));
// /connect3 (2026-11-03): variante nueva con la marca InvokeApp, distinta de /connect.
const Connect3BrandPage = lazy(() => import('./pages/Connect/variants/Connect3BrandPage'));
// Tercera tanda (2026-11-04): ocho territorios de marca para el rebranding de InvokeApp y Connect.
const Connect8Page = lazy(() => import('./pages/Connect/variants/Connect8Page'));
const Connect9Page = lazy(() => import('./pages/Connect/variants/Connect9Page'));
const Connect10Page = lazy(() => import('./pages/Connect/variants/Connect10Page'));
const Connect11Page = lazy(() => import('./pages/Connect/variants/Connect11Page'));
const Connect12Page = lazy(() => import('./pages/Connect/variants/Connect12Page'));
const Connect13Page = lazy(() => import('./pages/Connect/variants/Connect13Page'));
const Connect14Page = lazy(() => import('./pages/Connect/variants/Connect14Page'));
const Connect15Page = lazy(() => import('./pages/Connect/variants/Connect15Page'));
// Cuarta tanda (2026-11-04): quince relatos del ecosistema InvokeApp (consultoría, plataforma y Connect).
const Connect16Page = lazy(() => import('./pages/Connect/variants/Connect16Page'));
const Connect17Page = lazy(() => import('./pages/Connect/variants/Connect17Page'));
const Connect18Page = lazy(() => import('./pages/Connect/variants/Connect18Page'));
const Connect19Page = lazy(() => import('./pages/Connect/variants/Connect19Page'));
const Connect20Page = lazy(() => import('./pages/Connect/variants/Connect20Page'));
const Connect21Page = lazy(() => import('./pages/Connect/variants/Connect21Page'));
const Connect22Page = lazy(() => import('./pages/Connect/variants/Connect22Page'));
const Connect23Page = lazy(() => import('./pages/Connect/variants/Connect23Page'));
const Connect24Page = lazy(() => import('./pages/Connect/variants/Connect24Page'));
const Connect25Page = lazy(() => import('./pages/Connect/variants/Connect25Page'));
const Connect26Page = lazy(() => import('./pages/Connect/variants/Connect26Page'));
const Connect27Page = lazy(() => import('./pages/Connect/variants/Connect27Page'));
const Connect28Page = lazy(() => import('./pages/Connect/variants/Connect28Page'));
const Connect29Page = lazy(() => import('./pages/Connect/variants/Connect29Page'));
const Connect30Page = lazy(() => import('./pages/Connect/variants/Connect30Page'));
// Quinta tanda (2026-11-04): seis relatos nuevos a partir de lo que el owner eligió de la 7 a la 30.
const Connect31Page = lazy(() => import('./pages/Connect/variants/Connect31Page'));
const Connect32Page = lazy(() => import('./pages/Connect/variants/Connect32Page'));
const Connect33Page = lazy(() => import('./pages/Connect/variants/Connect33Page'));
const Connect34Page = lazy(() => import('./pages/Connect/variants/Connect34Page'));
const Connect35Page = lazy(() => import('./pages/Connect/variants/Connect35Page'));
const Connect36Page = lazy(() => import('./pages/Connect/variants/Connect36Page'));
// Sexta tanda (2026-11-04, owner: «mezcla de tech con historia, mapa y storytelling de arquitectura tech»).
const Connect37Page = lazy(() => import('./pages/Connect/variants/Connect37Page'));
const Connect38Page = lazy(() => import('./pages/Connect/variants/Connect38Page'));
const Connect39Page = lazy(() => import('./pages/Connect/variants/Connect39Page'));
// Séptima tanda (2026-11-04, owner: más disruptiva, letra de la 28, invocar, colores de marca y un mapa antiguo).
const Connect40Page = lazy(() => import('./pages/Connect/variants/Connect40Page'));
const Connect41Page = lazy(() => import('./pages/Connect/variants/Connect41Page'));
const Connect42Page = lazy(() => import('./pages/Connect/variants/Connect42Page'));
const Connect43Page = lazy(() => import('./pages/Connect/variants/Connect43Page'));
const Connect44Page = lazy(() => import('./pages/Connect/variants/Connect44Page'));
// Índice con las miniaturas de todas las variantes de Connect.
const Connect100Page = lazy(() => import('./pages/Connect/variants/Connect100Page'));


// import ReactGA from 'react-ga';

const Privacy = lazy(() => import('./pages/Policies/Privacy'));
const Terms = lazy(() => import('./pages/Policies/Terms'));
const LegalDocPage = lazy(() => import('./pages/Policies/LegalDocPage'));
// Versiones de los textos legales (cláusula 14.3 de las condiciones) y cada versión archivada.
const LegalHistory = lazy(() => import('./pages/Policies/LegalHistory'));
const LegalHistoryVersion = lazy(() => import('./pages/Policies/LegalHistoryVersion'));
// import NewsletterPolicies from './pages/Policies/NewsletterPolicies';
// import EBookPolicies from './pages/Policies/EBookPolicies';
// import CommentPolicies from './pages/Policies/CommentsPolicies';
// import ContactPolicies from './pages/Policies/ContactPolicies';
// import CookiesPolicies from './pages/Policies/CookiesPolicies';

// import LeadConversion from './pages/Integrations/LeadConversion';
const Landing = lazy(() => import('./pages/Landing/Landing'));
const Partners = lazy(() => import('./pages/Partners/Partners'));
const Product = lazy(() => import('./pages/Product/Product'));
const Scale = lazy(() => import('./pages/Scale/Scale'));
const Explore = lazy(() => import('./pages/Explore/Explore'));
const Affiliates = lazy(() => import('./pages/Affiliates/Affiliates'));
const AffiliateDashboard = lazy(() => import('./pages/Affiliates/Dashboard/AffiliateDashboard'));
const AffiliatesGuide = lazy(() => import('./pages/Affiliates/Guide/AffiliatesGuide'));
const Investors = lazy(() => import('./pages/Investors/Investors'));
const OauthStatus = lazy(() => import('./pages/Oauth/OauthStatus'));
const PaymentsMessage = lazy(() => import('./pages/Payments/PaymentsMessage'));
// App de los asistentes (PWA instalable, maqueta): agencia y cliente final.
const AssistantApp = lazy(() => import('./pages/AssistantApp/AssistantApp'));


const TRACKING_ID = "G-4D8F3VPCBG"; // OUR_TRACKING_ID




  

// /embed vive dentro de la web de una agencia y su query string lleva la clave
// de embebido de esa agencia. El page_view por defecto de GA4 manda la URL
// completa (page_location), así que ahí no se inicia Analytics ni se envía nada.
// Lo mismo en /playbook-demo/component, que vive dentro de CORE-Front (ver
// isFramedPath en lib/embedRoute.js).
const IS_FRAMED = isFramedLocation();
// La app de los asistentes (/app) tampoco lleva analítica.
const NO_ANALYTICS = IS_FRAMED || isAppLocation();

// Google Analytics instala cookies de análisis: solo se inicia con el consentimiento del
// visitante (LSSI art. 22.2). Si ya lo dio en una visita anterior, se inicia al cargar; si
// no, lo inicia el botón «Aceptar» de la barra de cookies (CookieBanner).
const startAnalytics = () => {
  if (NO_ANALYTICS || ReactGA.isInitialized) return;
  ReactGA.initialize(TRACKING_ID);
  ReactGA.send({ page: window.location.pathname });
};
if (!NO_ANALYTICS && hasAnalyticsConsent()) startAnalytics();


// ReactGA.pageview(window.location.pathname + window.location.search);




// La barra del webinar es marca de InvokeApp: no puede aparecer encima de una
// demo que lleva la marca de un cliente.
const SiteChrome = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith('/playbook-demo') || isFramedPath(pathname) || isAppPath(pathname)) return null;
  return <WebinarTopBar/>;
};

function App() {
useEffect(() => {
  if (NO_ANALYTICS) return undefined;
  const handlePageChange = () => {
    if (!ReactGA.isInitialized) return;
    // ReactGA.pageview(window.location.pathname);
    // ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Custom Title" });
    ReactGA.send({ page: window.location.pathname });

  };

  window.addEventListener('popstate', handlePageChange);
  handlePageChange();

  return () => {
    window.removeEventListener('popstate', handlePageChange);
  };
}, []);


  // "start": "react-scripts start",
  // "build": "react-scripts build",
  

  
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollTop/>
        <SiteChrome/>
        <WebAssistantHomeOnly/>
        <BrandCursor/>
        <CookieBanner onAccept={startAnalytics}/>
        <AppErrorBoundary>
        <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
        <Routes>

            {/* HOME SECTION */}
            <Route path="/" element={<Home/>} />
            <Route path="/home" element={<Home/>} />
            
            {/* HIDDEN SECTION */}
            <Route path="/investors" element={<Investors/>} />

            {/* INTERESTING COMPONENTS FOR MAIN PAGE IN PAGE TWO */}
            {/* INTERESTING COMPONENTS FOR MAIN PAGE IN PAGE TWO */}
            {/* INTERESTING COMPONENTS FOR MAIN PAGE IN PAGE TWO */}
            
            {/* <Route path="/homeTwo" element={<HomeTwo/>} /> */}
            {/* INTERESTING POWER WORDS IN THESE TEMPLATES || LOOK UP MORE LATER  ********************* */}
            {/* <Route path="/homeThree" element={<HomeThree/>} />  */}


            <Route path="/privacy" element={<Privacy/>} />
            <Route path="/terms" element={<Terms/>} />
            <Route path="/cookies-policies" element={<LegalDocPage docKey="cookies" titleKey="page_title_cookies" metaKey="cookies_meta"/>} />
            <Route path="/legal-notice" element={<LegalDocPage docKey="legal-notice" titleKey="page_title_legal_notice" metaKey="legal_notice_meta"/>} />
            <Route path="/data-deletion" element={<LegalDocPage docKey="data-deletion" titleKey="page_title_data_deletion" metaKey="data_deletion_meta"/>} />
            <Route path="/subprocessors" element={<LegalDocPage docKey="subprocessors" titleKey="page_title_subprocessors" metaKey="subprocessors_meta"/>} />
            <Route path="/dpa" element={<LegalDocPage docKey="dpa" titleKey="page_title_dpa" metaKey="dpa_meta"/>} />
            {/* Histórico legal (src/data/legalHistory.js, generado por scripts/build-legal.js). Las
                versiones no tienen rewrite en firebase.json: prerender.js escribe la página de cada
                versión que existe y las demás responden 404. */}
            <Route path="/legal/history" element={<LegalHistory/>} />
            <Route path="/legal/history/:doc/:version" element={<LegalHistoryVersion/>} />
            {/* <Route path="/newsletter-policies" element={<NewsletterPolicies/>} />
            <Route path="/ebook-policies" element={<EBookPolicies/>} />
            <Route path="/comments-policies" element={<CommentPolicies/>} />
            <Route path="/contact-policies" element={<ContactPolicies/>} />
*/}


            {/* <Route path="/time-maximization" element={<Services/>} />
            <Route path="/operational-efficiency" element={<Services/>} />
            <Route path="/customer-retention" element={<Services/>} />
            <Route path="/lead-conversion" element={<LeadConversion/>} /> */}



            {/* <Route path="/headerStyleFour" element={<HeaderStyleFour/>} />
            <Route path="/headerStyleFive" element={<HeaderStyleFive/>} />
            <Route path="/headerStyleSix" element={<HeaderStyleSix/>} />
            <Route path="/headerStyleSeven" element={<HeaderStyleSeven/>} /> */}



            {/* ABOUT SECTION */}
            <Route path="/about" element={<About/>} />


            {/* SERVICES SECTION */}
            <Route path="/services" element={<Services/>} />
            <Route path="/service-detail" element={<ServiceDetail/>} />

            {/* <Route path="/servicesDetails" element={<ServicesDetails/>} /> */} {/* FUTURE USE FOR APP DETAIL */}


            {/* CORE PRELAUNCH SECTION */}
            <Route path="/core" element={<CorePrelaunch/>} /> {/* FUTURE USE FOR APP DETAIL */}
            
            {/* <Route path="/demo" element={<CorePrelaunch/>} /> FUTURE USE FOR APP DETAIL */}


            {/* PORTFOLIO SECTION */}
            <Route path="/portfolio" element={<Portfolio/>} />
            
            
            


            {/* https://sca.core.invokeapp.io/sca/hasttest/form/ */}
            {/* https://sca.core.invokeapp.io/sca/hasttest/form/ */}
            {/* https://sca.core.invokeapp.io/sca/hasttest/form/ */}
            {/* https://sca.core.invokeapp.io/sca/hasttest/form/ */}
            {/* https://sca.core.invokeapp.io/sca/hasttest/form/ */}
            <Route path="/activation" element={<SCActivation/>} />
            {/* https://sca.core.invokeapp.io/sca/hasttest/form/ */}
            {/* https://sca.core.invokeapp.io/sca/hasttest/form/ */}
            {/* https://sca.core.invokeapp.io/sca/hasttest/form/ */}
            {/* https://sca.core.invokeapp.io/sca/hasttest/form/ */}
            {/* https://sca.core.invokeapp.io/sca/hasttest/form/ */}
            {/* https://sca.core.invokeapp.io/sca/hasttest/form/ */}
            {/* https://sca.core.invokeapp.io/sca/hasttest/form/ */}
            {/* https://sca.core.invokeapp.io/sca/hasttest/form/ */}






            {/* <Route path="/portfolioDetails" element={<PortfolioDetails/>} />  */}
            {/* FUTURE USE FOR APP DETAIL */}

            {/* OCULTA 2026-10-28: <Route path="/team" element={<Team/>} /> */}
            {/* <Route path="/teamDetails" element={<TeamDetails/>} /> */}



            <Route path="/resources" element={<Resources/>} />
            <Route path="/jobs" element={<Jobs/>} />
            <Route path="/press" element={<Press/>} />



            {/* BLOG SECTION — lo sirve Next.js vía rewrite de Firebase Hosting.
                La ruta /blog-details/:id se quitó: duplicaba el mismo artículo en dos
                URLs (contenido duplicado para Google). Las URLs antiguas se redirigen
                con un 301 a /blog/:slug desde firebase.json. */}
            <Route path="/blog" element={<BlogHandoff/>} />
            <Route path="/blog/*" element={<BlogHandoff/>} />


            {/* LANDING */}
            <Route path="/agencies" element={<Landing/>} />
            <Route path="/partners" element={<Partners/>} />
            <Route path="/product" element={<Product/>} />
            <Route path="/scale" element={<Scale/>} />
            <Route path="/explore" element={<Explore/>} />
            <Route path="/affiliates" element={<Affiliates/>} />
            <Route
               path="/affiliates/dashboard"
               element={<RequireSession kind="affiliate"><AffiliateDashboard/></RequireSession>}
            />
            <Route path="/affiliates/guide" element={<AffiliatesGuide/>} />


            {/* ERROR PAGES */}
            <Route path="/error-404" element={<Error404/>} />
            
            {/* CONTACT */}
            <Route path="/contact" element={<Contact/>} />
            <Route path="/faq" element={<Faq/>} />

            <Route path="/oauth/status" element={<OauthStatus/>} />
            <Route path="/payments" element={<PaymentsMessage/>} />



            {/* FOOTER */}
            <Route path="/pricing" element={<Pricing/>} />
            <Route path="/documentation" element={<Documentation/>} />
            <Route path="/partnerships" element={<Partnerships/>} />
            <Route path="/playbooks" element={<Playbooks/>} />
            <Route path="/playbook-demo" element={<PlaybookDemo/>} />
            <Route path="/playbook-demo/assistants" element={<AssistantsPreview/>} />
            <Route path="/playbook-demo/component" element={<ComponentPreview/>} />
            <Route path="/embed" element={<PlaybookEmbed/>} />
            <Route path="/demo" element={<Demo/>} />
            <Route path="/demo/agent-commercial" element={<DemoAgentCommercial/>} />
            <Route path="/operators" element={<Operators/>} />
            <Route path="/reviews" element={<Reviews/>} />
            <Route path="/platform" element={<Platform/>} />
            <Route path="/changelog" element={<Changelog/>} />
            <Route path="/guidelines" element={<Guidelines/>} />
            <Route path="/roadmap" element={<FeatureVote/>} />
            <Route path="/how-it-works" element={<HowItWorks/>} />
            <Route path="/get-started" element={<GetStarted/>} />

            {/* RECURSOS. Layout propio: cabecera minima, sin nav del sitio y sin
                ningun widget flotante (ver AiKitShell). La confirmacion de la
                solicitud vive DENTRO del propio formulario, no en otra ruta. */}
            <Route path="/resources/ai-kit" element={<AiKitLanding/>} />
            {/* Lead magnet del sistema comercial con IA (destino del QR del dossier). */}
            <Route path="/resources/ai-commercial-system" element={<AiCommercialLanding/>} />
            <Route path="/ai-sales-follow-up" element={<SalesFollowUpLanding/>} />
            <Route path="/ai-consulting" element={<ConsultingLanding/>} />
            <Route path="/connect" element={<ConnectPage/>} />
            {/* /connect3 es otra variante, con la marca InvokeApp; /connect sigue con Connect3Page. */}
            <Route path="/connect3" element={<Connect3BrandPage/>} />
            <Route path="/connect2" element={<Connect2Page/>} />
            <Route path="/connect4" element={<Connect4Page/>} />
            <Route path="/connect5" element={<Connect5Page/>} />
            <Route path="/connect6" element={<Connect6Page/>} />
            <Route path="/connect7" element={<Connect7Page/>} />
            <Route path="/connect8" element={<Connect8Page/>} />
            <Route path="/connect9" element={<Connect9Page/>} />
            <Route path="/connect10" element={<Connect10Page/>} />
            <Route path="/connect11" element={<Connect11Page/>} />
            <Route path="/connect12" element={<Connect12Page/>} />
            <Route path="/connect13" element={<Connect13Page/>} />
            <Route path="/connect14" element={<Connect14Page/>} />
            <Route path="/connect15" element={<Connect15Page/>} />
            <Route path="/connect16" element={<Connect16Page/>} />
            <Route path="/connect17" element={<Connect17Page/>} />
            <Route path="/connect18" element={<Connect18Page/>} />
            <Route path="/connect19" element={<Connect19Page/>} />
            <Route path="/connect20" element={<Connect20Page/>} />
            <Route path="/connect21" element={<Connect21Page/>} />
            <Route path="/connect22" element={<Connect22Page/>} />
            <Route path="/connect23" element={<Connect23Page/>} />
            <Route path="/connect24" element={<Connect24Page/>} />
            <Route path="/connect25" element={<Connect25Page/>} />
            <Route path="/connect26" element={<Connect26Page/>} />
            <Route path="/connect27" element={<Connect27Page/>} />
            <Route path="/connect28" element={<Connect28Page/>} />
            <Route path="/connect29" element={<Connect29Page/>} />
            <Route path="/connect30" element={<Connect30Page/>} />
            <Route path="/connect31" element={<Connect31Page/>} />
            <Route path="/connect32" element={<Connect32Page/>} />
            <Route path="/connect33" element={<Connect33Page/>} />
            <Route path="/connect34" element={<Connect34Page/>} />
            <Route path="/connect35" element={<Connect35Page/>} />
            <Route path="/connect36" element={<Connect36Page/>} />
            <Route path="/connect37" element={<Connect37Page/>} />
            <Route path="/connect38" element={<Connect38Page/>} />
            <Route path="/connect39" element={<Connect39Page/>} />
            <Route path="/connect40" element={<Connect40Page/>} />
            <Route path="/connect41" element={<Connect41Page/>} />
            <Route path="/connect42" element={<Connect42Page/>} />
            <Route path="/connect43" element={<Connect43Page/>} />
            <Route path="/connect44" element={<Connect44Page/>} />
            <Route path="/connect100" element={<Connect100Page/>} />
            <Route path="/product-tour" element={<ProductTour/>} />
            <Route path="/customer-portal" element={<CustomerPortal/>} />
            {/* Zona privada: sin sesión válida, RequireSession devuelve al login */}
            <Route
               path="/customer-portal/dashboard"
               element={<RequireSession kind="portal"><CustomerPortalDashboard/></RequireSession>}
            />

            {/* CATCH-ALL 404: cualquier ruta no listada cae en la pagina 404 */}
            <Route path="/app/*" element={<AssistantApp/>} />
            <Route path="*" element={<Error404/>} />

        </Routes>
        </Suspense>
        </AppErrorBoundary>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
